var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editable-cell"},[_c('div',{staticClass:"editable-cell-input-wrapper"},[_c('a-input',{attrs:{"placeholder":"请输入列宽","value":_vm.value},on:{"blur":_vm.onBlur,"change":_vm.handleChange,"pressEnter":_vm.check}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }